import loginDialog from "./login";
import saas from "./saas/component";

const components = [...loginDialog, ...saas];

function install(Vue) {
  components.forEach((it) => {
    Vue.component(it.name, it);
    if (!window.$components['nc']) {
      window.$components['nc'] = {}
    }
    window.$components['nc'][it.name] = it;
  })
}

if (typeof window !== "undefined" && window.Vue) {
  install(window.Vue);
}

export {
  install
};

export default install